import currency from "currency.js";
import { useStoreState } from "easy-peasy";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Table, Button, Accordion, Modal } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { appSettings } from "../../config";
import printJS from "print-js";
import { convertToBaseCurrency, fetchActionsUtil } from "../../utils/helpers";
import ConvertQuantity from "../utils/ConvertQuantity";

const CartStash = ({
  onHide,
  backendUrl,
  staff_id,
  // cartStash,
  // setCartStash,
  onRestoreCart,
  currencySymbol,
}) => {
  const [show, setShow] = useState(true);
  const [cartStash, setCartStash] = useState([]);
  const generalSettings = useStoreState((state) => state.generalSettings);
  const [isPrinting, setIsPrinting] = useState(false);
  const [itemPrinting, setItemPrinting] = useState("");
  const getAllStash = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/items/stash/${staff_id}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (!response.ok) {
        let error = await response.json();
        console.log(error.message);
        throw new Error(error.message);
      }
      const { data } = await response.json();

      let stash = data.map(({ items, total, stash_id, nominee = [] }) => ({
        items: items.map((item) => ({
          ...item,
          Item_Name: item?.data?.Item_Name,
          Item_id: item.Item_id,
          quantity: item?.data?.Quantity,
          price: item?.data?.PriceSold,
          SubTotal: item?.data?.SubTotal,
          data: item.data,
          customer: item?.customer || "",
          tableNumber: item?.tableNumber || "",
          customerData:
            typeof item?.customerData === "string"
              ? JSON.parse(item?.customerData)
              : item?.customerData || {},
        })),
        id: stash_id,
        totalPrice: total,
        nominee: nominee,
      }));
      setCartStash([...stash]);

      return data;
    } catch (error) {
      console.log(error.message);
      toast.error("Unable to get items");
    }
  };

  const { data, isLoading, error, refetch } = useQuery(
    "stash",
    getAllStash,
    {}
  );

  const handleDelete = async (index, id, tableNumber = "") => {
    // remove item from the stash
    let newStash = cartStash.filter((_, i) => i !== index);
    console.log("deleting index: ", newStash);

    await fetch(`${backendUrl}/api/items/stash/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ tableNumber, canceled: "canceled" }),

      credentials: "include",
    });
    setCartStash(newStash);
    // close the modal if the stash is empty
    if (newStash.length === 0) {
      onHide(false);
    }
  };

  const printInvoice = async (payload) => {
    if (
      payload.currency &&
      payload.currency !== generalSettings?.prevailingCurrency
    ) {
      payload = convertToBaseCurrency({
        data: payload,
        conversionAmount: payload.conversionAmount,
      });
    }
    /*  console.log("JJ", payload);
      return; */
    // const isThermalPrinter =
    //   appSettings.printerType?.toLowerCase() ===
    //   "Thermal Printer"?.toLowerCase();

    let response = await fetch(
      `${backendUrl}/api/invoice/view-invoice-for-none-posted-transactions?thermalPrinter=true`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      // alert(JSON.stringify(response));
      throw new Error(JSON.stringify(response));
    }
    const res = await response.json();
    return res;
  };

  const handlePrint = async (data) => {
    let values = data || {};

    const tableData = values?.items?.map((el) => el.data);
    const subTotal = values?.totalPrice;
    const amountDue = values?.totalPrice;
    const amount = values?.totalPrice;

    // check customer for existing customers
    const customerData = values?.items;

    let customer = !isEmpty(customerData[0]?.customerData)
      ? JSON.parse(customerData[0]?.customerData)
      : {
          numberPrefix: null,
          currentNumber: null,
          Cust_ID: "",
          FirstName: "",
          MiddleName: "",
          LastName: customerData[0]?.customer || "",
          DOB: "",
          PhoneNo1: "",
          PhoneNo2: null,
          CompanyAddress: "",
          ContactAddress: "",
          Office_PhoneNo: null,
          Email: "",
          Name_Add_work: null,
          Name_Add_sch: null,
          Highest_Qual: null,
          Name_Institution: null,
          Year_attained: null,
          How_Did_Know: "",
          TransType: "",
          Product_Int1: "None",
          Product_Int2: "None",
          FollowUpComment: "",
          DateLog: "",
          PhotoPath: null,
          Branch: "",
          Dept: "Sales",
          password: "",
          Gender: null,
          Post_Time: "",
          state: null,
          LGA: null,
          Group: "",
          referal_EmployeeID: null,
          verifyToken: null,
          onlineStoreInventorySource: "",
          onlineStoreInventorySourceName: "",
          country: null,
          customerApprovePendingOnlineOrders: false,
          Staff_ID: null,
        };

    const initialvalue = {
      tableNumber: customerData[0]?.tableNumber,

      items: tableData,
      deliveryInformation: [
        {
          Vendor_ID: "",
          Vendor_Name: "",
          ServiceChargePerLitre: 0,
          Volume: 0,
          Total: 0,
          DriverName: "",
          TruckNumber: "",
          InhouseLoading: false,
          VolumeLoaded: 0,
          VolumeSupplied: 0,
          ShortageVolume: 0,
          EmployeeID: "",
        },
      ],
      taxType: "None",
      creditLine: "",
      PaymentType: "Cash",
      proformaNumber: "",
      splitPaymentType: "",
      printWaybill: true,
      salesDate: moment(),
      invoiceCat: "",
      OverwriteOfficer: "Retail",
      chequeNumber: "",
      BankName: "",
      cashAmount: "",
      sendEmail: false,
      printReciept: true,
      dueIn: "",
      pendingTransaction: "",
      supplyNow: false,
      ShipTo: customer?.LastName || "Walk-In",
      customerBalance: "",
      amountToPayFromCustomerCredit: "0",
      printer: appSettings.printerType,
      posCharge: 0,
      loadingCharge: "",
      offloadingCharge: "",
      isBatchStandard: appSettings.isBatchStandard,
      transportCharge: "",
      Sale_Rep: "",
      Sale_Rep_Name: "",
      shippingCost: 0,
      otherCharges: 0,
      splitPaymentCardArray: [
        {
          amount: "",
          bank: "",
          posCharge: "",
          fixedAmount: "",
        },
      ],
      splitDirectBankTransferArray: [
        {
          amount: "",
          bank: "",
        },
      ],
      splitPaymentChequeArray: [
        {
          amount: "",
          bank: "",
          chequeNumber: "",
        },
      ],
      Bar_Code: "",
      currency: generalSettings?.prevailingCurrency,
      linkedPaymentID: "",
      jobNumber: "",
      poNumber: "", // GA
      milestone: "",
      conversionAmount: generalSettings.dollarInBaseCurrency,
      poNumber: "",
      lockBank: false,
      itemSearchCriteria: "Item_Code",
      amountFromCustomerBalance: 0,
      bankOnInvoice: "",
      taxes: [],
      generalDiscountType: "Fixed",
      generalDiscount: 0,
      generalDiscountPercentage: "",
      selectedAccountToPost: null,
      amountPaid: 0,
      summaryFromMultiplePayments: {},
      subTotal,
      discount: 0,
      amountDue,
      profit: "0",
      balance: "0.00",
      amount,
      customer: customer,
      taxValue: tableData[0]?.taxValue || "0.000",
      costOFSales: amount,
      salesIncome: 0,
      isRod: true,
      otherTaxValues: [],
    };
    setItemPrinting(data?.id);

    try {
      setIsPrinting(true);
      // setIstash()
      const data = await printInvoice(initialvalue);
      console.log(data);
      printJS({
        printable: data.html,
        type: "raw-html",
        targetStyles: ["*"],
      });
    } catch (error) {
    } finally {
      setIsPrinting(false);
      setItemPrinting("");
    }
  };

  const handleItemDeleteMutation = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/items/remove-stash/${payload?.cartId}`,
        "DELETE",
        "",
        payload
      ),
    {
      onSuccess: () => {
        toast.success("Item removed successfully");
        refetch();
      },
      onError: (error) => {
        toast.error("Unable to remove item: " + error?.message);
      },
    }
  );

  const handleDeleteEach = async ({ item, index, cartId, tableNumber }) => {
    handleItemDeleteMutation.mutate({
      item,
      cartId,
      tableNumber,
      index,
    });
    //  try {

    //  } catch (error) {

    //  }

    //   await fetchActionsUtil(
    //     `${backendUrl}/api/items/remove-stash/${cartId}`,
    //     "DELETE",
    //     "",
    //     {
    //       item,
    //       cartId,
    //       tableNumber,
    //       index,
    //     }
    //   );

    //   refetch();
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
        onHide(false);
      }}
      size="lg"
      style={{
        fontSize: "18px",
      }}
      className="stash-modal mt-4 side-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="pd-4">Cart Stash </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Accordion defaultActiveKey="0">
          {cartStash.length ? (
            cartStash.map((cart, cartIndex) => (
              <Accordion.Item eventKey={cartIndex.toString()} key={cartIndex}>
                <Accordion.Header>
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="">
                      {!isEmpty(cart?.items) && cart?.items[0]?.customer && (
                        <div>
                          <div className="d-flex  gap-4   align-items-center mb-3">
                            <b style={{ fontSize: "1.1rem" }}>
                              {cart?.items[0]?.customerData?.FirstName || ""}{" "}
                              {cart?.items[0]?.customerData?.LastName || ""}
                            </b>
                            <b>
                              {cart?.items[0]?.tableNumber
                                ? `Table No:  (${cart?.items[0]?.tableNumber})`
                                : ""}
                            </b>
                          </div>
                          {!isEmpty(cart?.nominee) && (
                            <div style={{ fontSize: "1.1rem" }}>
                              Nominee
                              {cart?.nominee?.map((nom) => (
                                <div className=" fw-normal  fst-italic">
                                  {nom?.FirstName || ""} {nom?.LastName || ""}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <span className=" d-flex align-items-center gap-2">
                      <Button
                        className=" btn print"
                        variant=""
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();

                          handlePrint(cart);
                        }}
                      >
                        {itemPrinting === cart?.id && isPrinting
                          ? "Printing"
                          : "Print Bill"}
                      </Button>
                      <Button
                        variant="outline-primary"
                        size="md"
                        className="mx-4"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent accordion toggle
                          onRestoreCart(cart.items, cart.id, cart?.nominee);
                        }}
                      >
                        Restore
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="md"
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(
                            cartIndex,
                            cart.id,
                            cart?.items[0]?.tableNumber
                          );
                        }}
                      >
                        Cancel All
                      </Button>
                    </span>
                  </div>
                </Accordion.Header>
                <Accordion.Body className="pd-4">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cart.items.map((item, itemIndex) => (
                        <tr key={itemIndex}>
                          <td>{item.Item_Name}</td>
                          <td>
                            <ConvertQuantity
                              quantity={item?.data?.Quantity}
                              desc={item?.data?.Item_Desc}
                              convertNow={true}
                              uomId={item?.data?.uomId}
                            />
                          </td>
                          <td>
                            <div className="d-flex justify-content-between align-content-center">
                              <span>
                                {currency(item.SubTotal, {
                                  symbol: currencySymbol,
                                }).format()}
                              </span>
                              <Button
                                variant="outline-danger"
                                size="md"
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteEach({
                                    index: cartIndex,
                                    cartId: cart.id,
                                    tableNumber: cart?.items[0]?.tableNumber,
                                    item,
                                  });
                                }}
                              >
                                Cancel
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={2} className="text-end">
                          <b>Total:</b>
                        </td>
                        <td>
                          <b>
                            {currency(cart.totalPrice, {
                              symbol: currencySymbol,
                            }).format()}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Accordion.Body>
              </Accordion.Item>
            ))
          ) : (
            <div className="text-center text-muted py-5">No stashed items.</div>
          )}
        </Accordion>
      </Modal.Body>
    </Modal>
  );
};

export default CartStash;
